export const PREPARE_INVOICE_DETAIL = "PREPARE_INVOICE_DETAIL"
export const GET_ADMIN_ORDERS = "GET_ADMIN_ORDERS"
export const GET_INVOICE_DETAIL = "GET_INVOICE_DETAIL"
export const PERSONAL_INVOICE_DETAIL = "PERSONAL_INVOICE_DETAIL"